import Dropdownable from 'custom_elements/dropdownable'

class SuscriptionSelector extends Dropdownable {
  init () {
    this.mainClass = 'rnk-SuscriptionSelector'
  }

  connectedCallback () {
    super.connectedCallback()
    this.getDefault()
    this.setSelectListener()
    this.statusCheck()
  }

  getDefault () {
    this.setSelected(this.querySelector('[data-default]'))
  }

  setSelectListener () {
    const optionsSelector = this.getAttribute('options')
    const options = this.querySelectorAll(optionsSelector)
    options.forEach( (option) => {
      option.addEventListener('click', () => {
        if (!option.classList.contains('selected')) {
          this.setSelected(option)
        }
      })
    })
  }

  statusCheck () {
    const notInForums = !document.location.pathname.startsWith('/foros')
    if (!(notInForums && this.hasAttribute('status') && document.querySelector('.rnk-Hero_Header'))) return

    this.status = this.getAttribute('status')
    this.eventName = `suscription-${this.status}`
    if (!window.hasOwnProperty('suscriptionStatus')) {
      window.suscriptionStatus = this.eventName
      return
    }
    if (window.suscriptionStatus === this.eventName) return

    const delta = this.status === 'following' ? 1 : -1
    this._updateSuscriptoresCounter(delta)
    window.suscriptionStatus = this.eventName
  }

  _updateSuscriptoresCounter (delta) {
    document.querySelectorAll('.rnk-Suscription_Counter, .rnk-Suscription_Counter-plain, dialog-title').forEach((el) => {
      el.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return
        const match = node.nodeValue.match(/(\s*)(\d[\d.,\s]*)(\s+suscriptores)/)
        if (!match) return
        const current = parseInt(match[2].replace(/\D/g, ''), 10)
        if (isNaN(current)) return
        node.nodeValue = `${match[1]}${current + delta}${match[3]}`
      })
    })
  }

  resetOptions () {
    this.querySelectorAll('.selected').forEach((item) => {
      item.classList.remove('selected')
    })
  }

  setSelected (option) {
    if (!option) { return }
    this.resetOptions()
    option.classList.add('selected')
  }
}

export default SuscriptionSelector
